import { EBasicField, EBasicFieldShort } from 'src/app/project/shared/enums/basic-fields-enums';
import { EIconPath } from 'src/app/project/shared/enums/icons.enum';
import { ECustomFieldType } from '../../../custom-fields/custom-field-types-enums';
import { EIntegrationStatus } from '../../../custom-fields/custom-fields.model';
import { GET_CUSTOM_FIELDS } from '../../../custom-fields/custom-fields.store';
import { TColumn } from '../../site-table/columns/column.model';
import { iconMap } from 'src/app/project/shared/enums/icon-map';

export function getFieldIcon(column: TColumn): EIconPath {
  if (column.customFieldIds?.length > 0) {
    return getCustomFieldIcon(column.customFieldIds[0]);
  }

  return getBasicFieldIcon(column);
}

export function getFieldIconFromFile(column: TColumn): string {
  if (column.customFieldIds?.length > 0) {
    return getCustomFieldIconFromFile(column.customFieldIds[0]);
  }

  return getBasicFieldIconFromFile(column);
}

export function getCustomFieldIconFromFile(customFieldId: string): string {
  const customFields = GET_CUSTOM_FIELDS();
  const customField = customFields[customFieldId];

  if (!customField) {
    return iconMap[EIconPath.ICON_ACTIVITIES_TEXT_14];
  }

  if (customField.volyIntegrationActive === EIntegrationStatus.ON) {
    return iconMap[EIconPath.ICON_INTEGRATION_VOLY_ACTIVE_SMALL];
  } else if (customField.volyIntegrationActive === EIntegrationStatus.DISABLED) {
    return iconMap[EIconPath.ICON_INTEGRATION_VOLY_INACTIVE_SMALL];
  }

  switch (customField.type) {
    case ECustomFieldType.TEXT:
      return iconMap[EIconPath.ICON_FIELDS_TEXT_14];
    case ECustomFieldType.LIST:
      return iconMap[EIconPath.ICON_FIELDS_LIST_14];
    case ECustomFieldType.MULTI_LIST:
      return iconMap[EIconPath.ICON_FIELDS_MULTI_LIST_14];
    case ECustomFieldType.DATE:
      return iconMap[EIconPath.ICON_FIELDS_DATE_14];
    case ECustomFieldType.COST:
      return iconMap[EIconPath.ICON_FIELDS_COST_14];
    case ECustomFieldType.NUMBERS:
      return iconMap[EIconPath.ICON_FIELDS_NUMBERS_14];
    case ECustomFieldType.RICHTEXT:
      return iconMap[EIconPath.ICON_FIELDS_RICH_TEXT_14];
    case ECustomFieldType.TIME:
      return iconMap[EIconPath.ICON_FIELDS_TIME_14];
    case ECustomFieldType.PERCENTAGE:
      return iconMap[EIconPath.ICON_FIELDS_PERCENTAGE_14];
    case ECustomFieldType.FORMULA:
      return iconMap[EIconPath.ICON_FIELDS_FORMULA_14];
    case ECustomFieldType.CHECKBOX:
      return iconMap[EIconPath.ICON_FIELDS_CHECKBOX_14];
    case ECustomFieldType.TIMELINE:
      return iconMap[EIconPath.ICON_FIELDS_TIMELINE_14];
  }
}

function getBasicFieldIconFromFile(column: TColumn): string {
  switch (column.name) {
    case EBasicField.ACCOUNT:
    case EBasicField.SITE:
    case EBasicField.DESCRIPTION:
    case EBasicField.TITLE:
      return iconMap[EIconPath.ICON_FIELDS_TEXT_14];
    case EBasicField.PRIORITY:
      return iconMap[EIconPath.ICON_ACTIVITIES_PRIORITY_14];
    case EBasicField.STATUS:
      return iconMap[EIconPath.ICON_ACTIVITIES_STATUS_14];
    case EBasicField.SEQUENCE_NUMBER:
    case EBasicFieldShort.SEQUENCE_NUMBER:
      return iconMap[EIconPath.ICON_FIELDS_NUMBERS_14];
    case EBasicField.CREATED:
    case EBasicField.UPDATED:
      return iconMap[EIconPath.ICON_FIELDS_DATE_14];
    case EBasicField.CREATED_BY:
    case EBasicField.ASSIGNEES:
      return iconMap[EIconPath.ICON_ACTIVITIES_USER_14];
    case EBasicField.TAGS:
      return iconMap[EIconPath.ICON_ACTIVITIES_TAGS_14];
    case EBasicField.FLAGGED:
    case EBasicFieldShort.FLAGGED:
      return iconMap[EIconPath.ICON_ACTIVITIES_RED_FLAG_14];
    default:
      return iconMap[EIconPath.ICON_ACTIVITIES_TEXT_14];
  }
}

export function getCustomFieldIcon(customFieldId: string): EIconPath {
  const customFields = GET_CUSTOM_FIELDS();
  const customField = customFields[customFieldId];

  if (!customField) {
    return EIconPath.ICON_ACTIVITIES_TEXT_14;
  }

  if (customField.volyIntegrationActive === EIntegrationStatus.ON) {
    return EIconPath.ICON_INTEGRATION_VOLY_ACTIVE_SMALL;
  } else if (customField.volyIntegrationActive === EIntegrationStatus.DISABLED) {
    return EIconPath.ICON_INTEGRATION_VOLY_INACTIVE_SMALL;
  }

  switch (customField.type) {
    case ECustomFieldType.TEXT:
      return EIconPath.ICON_FIELDS_TEXT_14;
    case ECustomFieldType.LIST:
      return EIconPath.ICON_FIELDS_LIST_14;
    case ECustomFieldType.MULTI_LIST:
      return EIconPath.ICON_FIELDS_MULTI_LIST_14;
    case ECustomFieldType.DATE:
      return EIconPath.ICON_FIELDS_DATE_14;
    case ECustomFieldType.COST:
      return EIconPath.ICON_FIELDS_COST_14;
    case ECustomFieldType.NUMBERS:
      return EIconPath.ICON_FIELDS_NUMBERS_14;
    case ECustomFieldType.RICHTEXT:
      return EIconPath.ICON_FIELDS_RICH_TEXT_14;
    case ECustomFieldType.TIME:
      return EIconPath.ICON_FIELDS_TIME_14;
    case ECustomFieldType.PERCENTAGE:
      return EIconPath.ICON_FIELDS_PERCENTAGE_14;
    case ECustomFieldType.FORMULA:
      return EIconPath.ICON_FIELDS_FORMULA_14;
    case ECustomFieldType.CHECKBOX:
      return EIconPath.ICON_FIELDS_CHECKBOX_14;
    case ECustomFieldType.TIMELINE:
      return EIconPath.ICON_FIELDS_TIMELINE_14;
  }
}

function getBasicFieldIcon(column: TColumn): EIconPath {
  switch (column.name) {
    case EBasicField.ACCOUNT:
    case EBasicField.SITE:
    case EBasicField.DESCRIPTION:
    case EBasicField.TITLE:
      return EIconPath.ICON_FIELDS_TEXT_14;
    case EBasicField.PRIORITY:
      return EIconPath.ICON_ACTIVITIES_PRIORITY_14;
    case EBasicField.STATUS:
      return EIconPath.ICON_ACTIVITIES_STATUS_14;
    case EBasicField.SEQUENCE_NUMBER:
    case EBasicFieldShort.SEQUENCE_NUMBER:
      return EIconPath.ICON_FIELDS_NUMBERS_14;
    case EBasicField.CREATED:
    case EBasicField.UPDATED:
      return EIconPath.ICON_FIELDS_DATE_14;
    case EBasicField.CREATED_BY:
    case EBasicField.ASSIGNEES:
      return EIconPath.ICON_ACTIVITIES_USER_14;
    case EBasicField.TAGS:
      return EIconPath.ICON_ACTIVITIES_TAGS_14;
    case EBasicField.FLAGGED:
    case EBasicFieldShort.FLAGGED:
      return EIconPath.ICON_ACTIVITIES_RED_FLAG_14;
    default:
      return EIconPath.ICON_ACTIVITIES_TEXT_14;
  }
}
